export default __webpack_public_path__ + "static/media/Banner2.7f6550f2.png";